<template>
  <div class="pesquisaContainer">
    <v-autocomplete
      class="input_de_pesquisa"
      :class="{ redBorda: redColorActive }"
      v-model="estudantePesquisa"
      :items="estudantesLista"
      :loading="isLoading_"
      :search-input.sync="search"
      color="primary"
      item-text="nome_matricula"
      item-value="nome"
      label="Nome ou Matrícula"
      append-icon="search"
      return-object
      @change="selecionarEstudante()"
      rounded
    >
      <template v-slot:label>
        <label>Nome do cliente</label>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import Swal from "sweetalert2";
const ls = require("local-storage");
export default {
  data() {
    return {
      estudantePesquisa: null,
      estudantesLista: [],
      estudanteSelecionado: [],
      isLoading_: false,
      search: "",
      foto: "",
    };
  },

  props: {
    redColorActive: Boolean,
  },

  watch: {
    /**
     * Método responsavél por observar sempre que o input é preenchido
     * Se o input tiver mais de suas palavras digitada,
     * executará a função InitializarEstudanteLocal()
     */
    search(val) {
      if (val && val.length > 2) {
        this.estudantes = [];
        this.InitializarEstudanteLocal(val);
      }
    },
  },

  methods: {
    /**
        * Método responsavél por carregar a lista de todos
        * estudante cujo a descrição bate com o valor inserido
        * Exibe uma notificação cajo ocorra um erro
    */
    async InitializarEstudanteLocal(searchDB) {
        try {
          this.isLoading_ = true;
          let payload = null;
          this.estudantePesquisa = null;
          this.estudantesLista = [];
          if (searchDB) payload = '{ "find" : "' + searchDB + '" }';
          else payload = '{ "find":"all" }';
            this.estudantesLista = await axios.get("/PesquisaClienteLocal/" + payload).then((res) => res.data);
        } catch (error) {
            Swal.fire("Informação", "Ocorreu um erro durante a pesquisa do estudante!", "error");
        } finally {
            this.isLoading_ = false;
        }
    },

    /**
     * Método responsavél por enviar o estudante escolhido para o componente pai
    */
    selecionarEstudante() {
        try {
            this.$emit("estudanteEscolhido", this.estudantePesquisa);
        } catch (error) {
            Swal.fire('informação','Erro ao enviar o estudante!', 'error')
        }
    },
  },
};
</script>

<style>
.pesquisaContainer {
    margin-left: 20px; 
    height: 40px;
}

.input_de_pesquisa {
  background-color: #f3eee3;
  height: 40px;
}

.redBorda {
  border: 2px dotted transparent;
  animation: flashBorder 0.5s linear infinite alternate;
}

@keyframes flashBorder {
  0% {
    border-color: transparent;
  }
  100% {
    border-color: #ff0000;
  }
}
</style>
